import { experimentalStyled } from "@material-ui/core/styles";
import { Link as RouterLink, useLocation } from "@tanstack/react-router";
import { Box, Typography } from "@material-ui/core";

const LogoContainer = experimentalStyled(Box)({
  display: "flex",
  alignItems: "center",
  gap: 6,
});

const LogoImage = experimentalStyled("img")(({ theme, size }) => ({
  height: size,
  width: size,
}));

// Styled RouterLink (removes underline & visited color)
const StyledRouterLink = experimentalStyled(RouterLink)({
  display: "inline-flex",
  alignItems: "center",
  textDecoration: "none",
  color: "inherit", // Inherit current text color
  "&:visited": {
    color: "inherit",
  },
});

const Logo = ({ size = 52, to = "/", ...props }) => {
  const location = useLocation();

  const handleClick = (e) => {
    if (location.pathname === "/" || location.pathname === "") {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  return (
    <StyledRouterLink to={to} onClick={handleClick}>
      <LogoContainer {...props}>
        <LogoImage src="/logo.svg" alt="Logo" size={size} />
        <Typography
          variant="h6"
          component="span"
          style={{ fontSize: size * 0.6, fontWeight: 600 }}
        >
          Lean Ads
        </Typography>
      </LogoContainer>
    </StyledRouterLink>
  );
};

export default Logo;
